import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CloudOff, X } from "lucide-react";
import { api } from "@/lib/api";

export const OFFLINE_TEXT = "Full-size photos and videos are taking a short break. Thumbnails still work, and everything will be back shortly.";
const KEY = "fa-offline-dismissed";
const REFRESH = "storage-status-refresh";

export const useStorageStatus = () => {
  const [s, setS] = useState({ drive: "ok" });
  useEffect(() => {
    let alive = true;
    const poll = () => api.get("/status/storage", { baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` })
      .then((r) => alive && setS(r.data)).catch(() => {});
    poll();
    const t = setInterval(poll, 60000);
    window.addEventListener(REFRESH, poll);
    return () => { alive = false; clearInterval(t); window.removeEventListener(REFRESH, poll); };
  }, []);
  return { ...s, refresh: () => window.dispatchEvent(new Event(REFRESH)) };
};

export const OfflineBanner = () => {
  const s = useStorageStatus();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY) === "1");
  const down = s.drive === "down" || s.drive === "reconnect";
  useEffect(() => { if (!down) { sessionStorage.removeItem(KEY); setDismissed(false); } }, [down]);
  if (!down || dismissed) return null;
  const d = s.detail;
  return (
    <div className="offline-banner" role="status" data-testid="offline-banner">
      <CloudOff size={16} className="shrink-0" />
      <span data-testid="offline-banner-text">{OFFLINE_TEXT}</span>
      {d && (
        <Link to="/settings?tab=storage" className="offline-detail" data-testid="offline-banner-admin-link">
          {s.drive === "reconnect" ? "OneDrive needs reconnecting" : "OneDrive details"}
        </Link>
      )}
      <button onClick={() => { sessionStorage.setItem(KEY, "1"); setDismissed(true); }} aria-label="Dismiss" data-testid="offline-banner-dismiss"><X size={15} /></button>
    </div>
  );
};
